export const TEXT = {
  SHOP_BANNER_PRETITLE: {id: 'shop.banner.title_A'},
  SHOP_BANNER_TITLE: {id: 'shop.banner.body_A'},
  SHOP_BANNER_TEXT: {id: 'shop.banner.text'},
  SHOP_BANNER_CTA: {id: 'shop.banner.CTA_A'},
  SHOP_BANNER_PRETITLE_B: {id: 'shop.banner.title_B'}, // TODO deprecated
  SHOP_BANNER_TITLE_B: {id: 'shop.banner.body_B'}, // TODO deprecated
  SHOP_BANNER_CTA_B: {id: 'shop.banner.CTA_B'}, // TODO deprecated
  SHOP_BANNER_BULLET_1: {id: 'shop.banner.bullet_1'}, // TODO deprecated
  SHOP_BANNER_BULLET_2: {id: 'shop.banner.bullet_2'}, // TODO deprecated
  SHOP_BANNER_BULLET_3: {id: 'shop.banner.bullet_3'}, // TODO deprecated
  SHOP_BANNER_BULLET_4: {id: 'shop.banner.bullet_4'}, // TODO deprecated
} as const;
